import { render } from "./TheBanner.vue?vue&type=template&id=f317660a&scoped=true"
import script from "./TheBanner.vue?vue&type=script&lang=js"
export * from "./TheBanner.vue?vue&type=script&lang=js"

import "./TheBanner.vue?vue&type=style&index=0&id=f317660a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f317660a"]])

export default __exports__